






































import {Component, Mixins} from 'vue-mixin-decorator';
import {getModule} from 'vuex-module-decorators';
import {Inject} from 'inversify-props';

import {EventBus} from '@/utils/EventBus';
import {Notify} from '@/utils/Notify';

import {INetworkDeviceService} from '@/services/network/INetworkDeviceService';

import NetworkDevicesStore from '@/store/network/NetworkDevices.store';
import {AppStore} from '@/store/App.store';

import {BaseComponent} from '@/mixins/BaseComponent';
import NetworkConnections from '@/components/Networking/Connection/NetworkConnections.vue';
import NetworkDevicesList from '@/components/Networking/Device/NetworkDevicesList.vue';
import NetworkDevices from '@/components/Networking/Device/NetworkDevices.vue';
import NetworkDeviceEthernet from '@/components/Networking/NetworkDeviceEthernet.vue';

@Component({
  components: {NetworkDeviceEthernet, NetworkDevicesList, NetworkConnections, NetworkDevices},
})
export default class NetworkEthernetPage extends Mixins<BaseComponent>(BaseComponent) {
  @Inject(Symbol.for('INetworkDeviceService'))
  private deviceService!: INetworkDeviceService;

  private appStore: AppStore = getModule(AppStore, this.$store);

  private devicesStore: NetworkDevicesStore = getModule(NetworkDevicesStore, this.$store);

  private selectedDevice: string | null = null;

  private async mounted() {
    await this.refresh();

    EventBus.Register(EventBus.Event.EthernetConnectionUpdated, async () => {
      await this.refresh();
    });
  }

  private async refresh() {
    this.logger.debug(`Refreshing data...`);

    this.setLoading();

    try {
      this.logger.debug(`Fetching network interfaces`);
      await this.devicesStore.fetchDevices(true);
      this.logger.debug(`Network interfaces fetched`, this.devicesStore.Devices);

      if (this.devicesStore.Devices) {
        this.selectedDevice = this.devicesStore.Devices[0].Id;
      }

    } catch (error) {
      Notify.Error(this.logger, `Could no get network interfaces`, error);
    } finally {
      this.setLoaded();
    }
  }
}
